import { createFileRoute } from "@tanstack/react-router";
import { ReporteriaBuilderPage } from "@/features/reporteria/components/ReporteriaBuilderPage";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";

/**
 * Ruta `/reporteria` · builder de reportes dinámicos del usuario (S11). Hotspot 92 ·
 * se entra con el permiso `reporteria.usar` (mismo que el menú y la política
 * `reporteria.acceso` del backend); la configuración asignada define qué se consulta.
 * Sin loader: el catálogo se carga dentro de la página.
 */
export const Route = createFileRoute("/_authed-tw/reporteria")({
  component: () => (
    <PermissionGate permisos={[PERMISOS.reporteriaUsar]}>
      <ReporteriaBuilderPage />
    </PermissionGate>
  ),
});
